/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_organization_business_address_zip_placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `110111`
};

const en_organization_business_address_zip_placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `110111`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const organization_business_address_zip_placeholder = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.organization_business_address_zip_placeholder(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("organization_business_address_zip_placeholder", locale)
	if (locale === "es") return es_organization_business_address_zip_placeholder(inputs)
	return en_organization_business_address_zip_placeholder(inputs)
};
export { organization_business_address_zip_placeholder as "organization.business_address.zip_placeholder" }